export default "/images/frontPageBackgroundImage1920x1280.jpg?46d09c961ebbb890aa42ecd4bf551939";